export const useTimer = (timeInSeconds: number, intervalDelayInMs: number = 1000) => {
  const time: Ref<number> = ref<number>(0);
  const interval: Ref<NodeJS.Timeout | null> = ref<NodeJS.Timeout | null>(null);

  const reset = () => {
    time.value = timeInSeconds;
  };

  const launch = () => {
    reset();

    interval.value = setInterval(() => {
      if (time.value === 0 && interval.value) {
        clearInterval(interval.value);
      } else {
        time.value--;
      }
    }, intervalDelayInMs);
  };

  onBeforeUnmount(() => {
    interval.value && clearInterval(interval.value);
  });

  return {
    time,
    launch,
  };
};
